import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import axios from 'axios';

function UpdateOfficials() {
    const { plantName, official_id, cogen_id } = useParams();
    const navigate = useNavigate();

    const [formData, setFormData] = useState({
        designation: '',
        officials_name: '',
        officials_email: '',
        mobile_no: '',
        phone_number: '',
    });

    const [errors, setErrors] = useState({});
    const [successMessage, setSuccessMessage] = useState('');

    // Fetch existing official
    useEffect(() => {
        const fetchOfficial = async () => {
            try {
                const res = await axios.get(`https://backend-zkgn.onrender.com/api/cogen_officials/${cogen_id}`);

                const found = res.data.find(
                    (off) => String(off.official_id) === String(official_id)
                );

                if (!found) {
                    alert("Official not found");
                    navigate(`/cogenplant-officials/${plantName}/${cogen_id}`);
                    return;
                }

                setFormData(found);

            } catch (err) {
                console.error("Error fetching official:", err.message);
            }
        };

        fetchOfficial();
    }, [official_id, cogen_id, plantName, navigate]);


    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
    };

    const validate = () => {
        let temp = {};
        let isValid = true;

        if (!formData.designation.trim()) {
            temp.designation = "Designation is required";
            isValid = false;
        }
        if (!formData.officials_name.trim()) {
            temp.officials_name = "Official's Name is required";
            isValid = false;
        }
        if (formData.officials_email && !/\S+@\S+\.\S+/.test(formData.officials_email)) {
            temp.officials_email = "Invalid email format";
            isValid = false;
        }
        if (!formData.mobile_no.trim()) {
            temp.mobile_no = "Mobile number is required";
            isValid = false;
        }

        setErrors(temp);
        return isValid;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!validate()) return;

        try {
            await axios.put(
                `https://backend-zkgn.onrender.com/api/cogen_officials/${official_id}`,
                formData
            );

            setSuccessMessage("Official updated successfully!");

            setTimeout(() => {
                navigate(`/cogenplant-officials/${plantName}/${cogen_id}`);
            }, 1500);

        } catch (err) {
            console.error("Update failed:", err.message);
            alert("Failed to update official");
        }
    };

    return (
        <div className="container my-5">
            <h4 className="mb-4 text-center">Update Plant Official</h4>

            {successMessage && (
                <div className="alert alert-success text-center">{successMessage}</div>
            )}

            <form onSubmit={handleSubmit} className="shadow p-4 rounded bg-light">
                <div className="row g-3">

                    <div className="col-md-6">
                        <label className="form-label">Designation</label>
                        <input
                            type="text"
                            className="form-control"
                            name="designation"
                            value={formData.designation}
                            onChange={handleChange}
                        />
                        {errors.designation && <small className="text-danger">{errors.designation}</small>}
                    </div>

                    <div className="col-md-6">
                        <label className="form-label">Official's Name</label>
                        <input
                            type="text"
                            className="form-control"
                            name="officials_name"
                            value={formData.officials_name}
                            onChange={handleChange}
                        />
                        {errors.officials_name && <small className="text-danger">{errors.officials_name}</small>}
                    </div>

                    <div className="col-md-6">
                        <label className="form-label">Official's Email (Optional)</label>
                        <input
                            type="email"
                            className="form-control"
                            name="officials_email"
                            value={formData.officials_email}
                            onChange={handleChange}
                        />
                        {errors.officials_email && <small className="text-danger">{errors.officials_email}</small>}
                    </div>

                    <div className="col-md-6">
                        <label className="form-label">Mobile Number</label>
                        <input
                            type="text"
                            className="form-control"
                            name="mobile_no"
                            value={formData.mobile_no}
                            onChange={handleChange}
                        />
                        {errors.mobile_no && <small className="text-danger">{errors.mobile_no}</small>}
                    </div>

                    <div className="col-md-6">
                        <label className="form-label">Phone Number (Optional)</label>
                        <input
                            type="text"
                            className="form-control"
                            name="phone_number"
                            value={formData.phone_number}
                            onChange={handleChange}
                        />
                    </div>

                </div>

                <div className="text-center mt-4">
                    <button type="submit" className="btn btn-primary px-4">Update Official</button>
                </div>
            </form>
        </div>
    );
}

export default UpdateOfficials;
